// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"X4-z","colorTextValue":"Y4-z","swatches":"Z4-z","collapseLink":"_4-z","isCollapsed":"a5-z","dropdown":"b5-z","disabled":"c5-z"};